import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { ApplicationConfig, ApplicationVolatile } from './app-config.model';

@EnableClassTelemetry()
@Injectable()
export class AppService {
  private static state: string;

  public getStateFromRoute(snapshot: ActivatedRouteSnapshot): string {
    const parts = [];

    for (const part of snapshot.pathFromRoot) {
      if (part.routeConfig && part.routeConfig.path !== '') {
        const path = part.routeConfig.path.replace(/:/g, '').replace(/\//g, '_');
        parts.push(path);
      }
    }

    return parts.join('_');
  }

  public getState(): string {
    return AppService.state;
  }

  public setState(state: string): void {
    const prevState = this.getState();

    if (state !== prevState) {
      const body = document.querySelector('body');
      body.classList.remove(`state-${prevState}`);
      AppService.state = state;
      body.classList.add(`state-${state}`);
    }
  }

  public syncTabMenu(route: string) {
    let activeTab = '';

    if (route.match('^/groups/.*/projects.*$')) {
      activeTab = 'projects';
    } else if (route.match('^/groups/.*/configurations')) {
      activeTab = 'configurations';
    } else if (route.match('^/groups/.*/configuration-routes')) {
      activeTab = 'routes';
    } else if (route.match('^/groups/.*/fields')) {
      activeTab = 'fields';
    } else if (route.match('^/groups/.*/action-plans')) {
      activeTab = 'action-plans';
    } else if (route.startsWith('/users')) {
      activeTab = 'users';
    } else if (route.startsWith('/user-groups')) {
      activeTab = 'groups';
    } else if (route.startsWith('/account')) {
      activeTab = '';
    }
    return { activeTab };
  }

  public static getConfig(): ApplicationConfig {
    return (window as any).appConfig || {};
  }

  public static getVolatile(): ApplicationVolatile {
    return (window as any).appVolatile;
  }

  public static hideBodyOverflow() {
    const body = document.querySelector('body');
    body.classList.add('body__hide-overflow');
  }

  public static showBodyOverflow() {
    const body = document.querySelector('body');
    body.classList.remove('body__hide-overflow');
  }
}
